import { Flex } from "monday-ui-react-core";

import { CommandListItem } from "./CommandListItem";
import type { CommandListProps } from "./CommandListProps";

export function CommandList({ commands, onCopy }: CommandListProps) {
  return (
    <Flex direction={Flex.directions.COLUMN} align={Flex.align.STRETCH} gap={Flex.gaps.SMALL}>
      {commands.map((command) => (
        <CommandListItem key={command.id} command={command} onCopy={() => onCopy(command)} />
      ))}
    </Flex>
  );
}
